import { Component, OnInit, Input } from '@angular/core';
import { PCCService } from 'src/app/services/pcc.service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-medications',
  templateUrl: './medications.component.html',
  styleUrls: ['./medications.component.css']
})
export class MedicationsComponent implements OnInit {

  @Input('patient') patient;
  // @Input('pccOrgUuid') pccOrgUuid;
  constructor(private _pccService: PCCService,
    private toastr:ToastrService,
    private loader: NgxUiLoaderService) { }
  pccOrgUuid:string;
  apiData;
  page = 1;
  dataSource;
  displayedColumns = [
    // "orderId",
    "startDate",
    // "generic",
    "description",
    "directions",
    // "strength",
    // "strengthUOM",
    // "pnId",
    // "ddId",
    // "rxNormId",
    "status",
    // "administration",
    // "schedules"
  ];

  loaderId ='medications-loader';
  inprogress = false;

  view:''|'administration'|'schedules' = '';
  viewData;

  ngOnInit(): void {
    this.pccOrgUuid = this.patient.facility_id_ref.pcc_orgUuid;
    this.loadData(this.page);
  }

  loadData(page) {
    this.loader.startLoader(this.loaderId);
    let authMode;
    if(!this.patient.facility_id_ref.pcc_2_legged_authentication) {
      authMode = 'APP'
    }
    this._pccService.getPatientMedications({
        pccOrgUuid: this.pccOrgUuid,
        pccPatientId: this.patient.pcc_patientId,
        pccFacID: this.patient.facility_id_ref.pcc_facId,
        pccPage: String(page),
        authMode
      }).subscribe((response: any) => {

      if (response.status === 200) {
        this.apiData = response.data;
        this.dataSource = new MatTableDataSource(this.apiData.data);
        this.page = page;
      } else {
        this.toastr.error('Something went wrong while fetching Medications data');
      }
    }, (error) => {
      this.toastr.error('Something went wrong while fetching Medications data');
    }, () => {
      this.loader.stopLoader(this.loaderId);
    })
  }
  navigate(prevNext) {
    const newPageNo = this.page + prevNext;
    this.loadData(newPageNo);
  }

  changeView(view, viewData) {
    this.view = view;
    this.viewData = viewData;

  }


}
